export const limitWords = (str, num) => {
  const words = str.split(' ')
  if (words.length <= num) {
    return str
  }
  return words.slice(0, num).join(' ') + ' ...'
}

export const extractFirstImage = (htmlContent, post = '') => {
  const fallback = '/images/tl_logo_meta.png'

  // 1. Try featured image from _embedded
  const media = post?._embedded?.['wp:featuredmedia']?.[0]
  const featuredImage = media?.media_details?.sizes?.['medium_large']?.source_url || media?.source_url

  if (featuredImage) {
    try {
      const safeUrl = featuredImage.replace('www.talentlift.ca', 'content.talentlift.ca')
      new URL(safeUrl) // validate URL
      return safeUrl
    } catch (e) {
      console.error('Invalid featured image URL:', featuredImage)
    }
  }

  // 2. Fallback to first <img> in HTML content
  if (htmlContent) {
    const imgRegex = /<img[^>]+src="([^">]+)"/i
    const match = imgRegex.exec(htmlContent)
    if (match && match[1]) {
      const imageUrl = match[1].replace('www.talentlift.ca', 'content.talentlift.ca')
      try {
        new URL(imageUrl)
        return imageUrl
      } catch (e) {
        console.error('Invalid image URL in HTML content:', imageUrl)
      }
    }
  }

  // 3. Fallback to default
  return fallback
}

export const roundIt = (num) => {
  const remainder = num % 1000

  if (remainder === 0) {
    return num.toLocaleString('en-US')
  } else {
    let result = Math.floor(num / 1000) * 1000
    result = result.toLocaleString('en-US')
    return result
  }
}

export const decodeHTMLEntities = (text) => {
  if (!text) return ''

  return text
    .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(dec)) // Decode numeric entities
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&ndash;/g, '–')
    .replace(/&mdash;/g, '—')
    .replace(/&hellip;/g, '…')
}
